export default (function (data) {
    return {
        withMiddleLine: !!(data === null || data === void 0 ? void 0 : data.withMiddleLine),
        lineType: (data === null || data === void 0 ? void 0 : data.lineType) || 'dashed',
        lineThickness: (data === null || data === void 0 ? void 0 : data.lineThickness) || 0.5,
        isDimesionTypeDiameter: (data === null || data === void 0 ? void 0 : data.hasOwnProperty('isDimesionTypeDiameter')) ? data.isDimesionTypeDiameter : true,
        isFlagLengthAuto: !!(data === null || data === void 0 ? void 0 : data.isFlagLengthAuto),
        textOrientation: (data === null || data === void 0 ? void 0 : data.textOrientation) || 'horizontal',
        slaveAngle: (data === null || data === void 0 ? void 0 : data.slaveAngle) || 0,
        flagLength: (data === null || data === void 0 ? void 0 : data.flagLength) || 25,
        flagMidLength: (data === null || data === void 0 ? void 0 : data.flagMidLength) || 22,
        cableDiameter: (data === null || data === void 0 ? void 0 : data.cableDiameter) || 7,
        isCableFlagSync: (data === null || data === void 0 ? void 0 : data.hasOwnProperty('isCableFlagSync')) ? data.isCableFlagSync : true,
        pages: data === null || data === void 0 ? void 0 : data.pages
    };
});
